import {
  Button,
  Dialog,
  DialogClose,
  DialogContent,
  Typography,
} from '@growdash/design-system/atoms';

import { useOnboarding } from '@growdash/growintel/hooks/useOnboarding';

export default function MenuAiOnboardingDialog() {
  const { markAsOnboarded, isOnboarded } = useOnboarding('ai');
  if (isOnboarded) return null;

  return (
    <Dialog
      defaultOpen
      onOpenChange={(open) => {
        if (!open) {
          markAsOnboarded();
        }
      }}
    >
      <DialogContent className="min-w-fit text-center px-36">
        <Typography className="font-bold text-2xl">
          Smarter menus in seconds
        </Typography>
        <Typography className="text-sm mt-4 !leading-[1.2em]">
          Aisha will serve up menu ideas, scroll-stopping descriptions at
          benchmarked prices all based on real delivery data.
        </Typography>
        <Typography className="text-sm mt-2">
          <strong>Your next best-seller? It’s one click away.</strong>
        </Typography>
        <div className="mt-10">
          <DialogClose onClick={markAsOnboarded}>
            <Button>Serve me ideas</Button>
          </DialogClose>
        </div>
      </DialogContent>
    </Dialog>
  );
}
